"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealDoorComponent = void 0;
var CustomEventTarget_1 = require("../helpers/CustomEventTarget");
var Types_1 = require("../Modules/Types");
var dom_interact_1 = require("../helpers/dom-interact");
var _ = __importStar(require("underscore"));
var tracker_1 = __importDefault(require("../helpers/tracker"));
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var DeviceManager_1 = require("./DeviceManager");
var TemplateIdentifiers;
(function (TemplateIdentifiers) {
    TemplateIdentifiers["MESSAGE_POPUP"] = "#message-popup-download-app";
})(TemplateIdentifiers || (TemplateIdentifiers = {}));
var baseStoreUrlByPlatform = {
    ios: 'https://apps.apple.com/app/apple-store/id6466997065?pt=113363803&mt=8',
    android: 'https://play.google.com/store/apps/details?id=company.celebrate.kartenmacherei',
};
var getStoreUrl = function (_a) {
    var platform = _a.platform, _b = _a.campaignName, campaignName = _b === void 0 ? '' : _b;
    var campaignParameterName = platform === 'ios' ? 'ct' : 'listing';
    if (campaignName.length) {
        return "".concat(baseStoreUrlByPlatform[platform], "&").concat(campaignParameterName, "=").concat(campaignName);
    }
    return baseStoreUrlByPlatform[platform];
};
var campaignNameByProductType = {
    ios: {
        photobook: 'KAM-web-redirect',
        poster: 'Posters-web-redirect',
    },
    android: {
        photobook: 'kam-web-redirect',
        poster: 'posters-kam-redirect',
    },
};
var productTypes = [
    {
        key: 'photobook',
        productGroups: ['FB', 'FF', 'FW', 'FV', 'V4', 'M1', 'FG', 'FI', 'FS', 'FC', 'FJ'],
    },
    {
        key: 'poster',
        productGroups: ['UP', 'VP', 'MP'],
    },
];
var trackingByProductType = {
    photobook: {
        popupClose: TrackingTypes_1.TrackingData.ACTION_REAL_DOOR_POPUP_CLOSE,
        downloadClick: TrackingTypes_1.TrackingData.ACTION_REAL_DOOR_DOWNLOAD_APP_CLICK,
        goToWebClicked: TrackingTypes_1.TrackingData.ACTION_REAL_DOOR_GO_TO_CONFIGURATOR_CLICK,
    },
    poster: {
        popupClose: TrackingTypes_1.TrackingData.ACTION_POSTER_REAL_DOOR_POPUP_CLOSE,
        downloadClick: TrackingTypes_1.TrackingData.ACTION_POSTER_REAL_DOOR_DOWNLOAD_APP_CLICK,
        goToWebClicked: TrackingTypes_1.TrackingData.ACTION_POSTER_REAL_DOOR_GO_TO_CONFIGURATOR_CLICK,
    },
};
var RealDoorComponent = /** @class */ (function (_super) {
    __extends(RealDoorComponent, _super);
    function RealDoorComponent(opts) {
        var _this = _super.call(this) || this;
        _this.configuratorButtons = opts.configuratorButtons;
        _this.cookies = opts.cookies;
        _this.platform = DeviceManager_1.DeviceManager.isIOS() ? 'ios' : 'android';
        _this.productGroup = opts.productGroup;
        _this.productType = _this.getProductTypeByProductGroup(_this.productGroup);
        _this.campaignName = _this.getCampaignName(_this.productType);
        _this.attachEvents();
        return _this;
    }
    RealDoorComponent.prototype.attachEvents = function () {
        var _this = this;
        _.each(this.configuratorButtons, function (button) {
            button.addEventListener('click', function () {
                // cookie name updated from "downloadAppModalShown" to "downloadAppModalShown_1" to reset for new Posters products
                if (_this.cookies.checkIfCookieSet('downloadAppModalShown_1')) {
                    return;
                }
                _this.cookies.setCookie('downloadAppModalShown_1', 30);
                var popupTemplate = _this.getRealDoorPopupTemplate();
                _this.openPopup(popupTemplate);
            });
        });
    };
    RealDoorComponent.prototype.getRealDoorPopupTemplate = function () {
        var _this = this;
        var contentTemplate = JSON.parse((0, dom_interact_1.getHTMLElement)(document, TemplateIdentifiers.MESSAGE_POPUP).innerHTML);
        var overlayAndCloseButtonTemplate = this.getOverlayAndCloseButtonTemplate({
            trackingAction: trackingByProductType[this.productType].popupClose,
        });
        var downloadAppBtn = contentTemplate.find(function (templateComponent) {
            return !!(templateComponent.type &&
                templateComponent.type === Types_1.DownloadAppModalTemplateComponentTypes.DOWNLOAD_APP);
        });
        if (downloadAppBtn) {
            downloadAppBtn.handler = function () {
                _this.closePopup({
                    trackingAction: trackingByProductType[_this.productType].downloadClick,
                });
                window.location.href = getStoreUrl({
                    platform: _this.platform,
                    campaignName: _this.campaignName,
                });
            };
        }
        this.trackGoToConfiguratorClick(contentTemplate, trackingByProductType[this.productType].goToWebClicked);
        return __spreadArray(__spreadArray([], overlayAndCloseButtonTemplate, true), contentTemplate, true);
    };
    RealDoorComponent.prototype.getOverlayAndCloseButtonTemplate = function (data) {
        var _this = this;
        return [
            {
                id: Types_1.MessagePopupElementIds.OVERLAY,
                handler: function () { return _this.closePopup(data); },
            },
            {
                id: Types_1.MessagePopupElementIds.CLOSE_BUTTON,
                handler: function () { return _this.closePopup(data); },
            },
        ];
    };
    RealDoorComponent.prototype.trackGoToConfiguratorClick = function (contentTemplate, trackingAction) {
        var goToConfiguratorBtn = contentTemplate.find(function (templateComponent) {
            return !!(templateComponent.type &&
                templateComponent.type === Types_1.DownloadAppModalTemplateComponentTypes.CONTINUE_ON_WEB);
        });
        if (goToConfiguratorBtn) {
            goToConfiguratorBtn.handler = function () {
                tracker_1.default.track({
                    category: TrackingTypes_1.TrackingData.PAGE_PDP,
                    action: trackingAction,
                });
            };
        }
    };
    RealDoorComponent.prototype.openPopup = function (popupTemplate) {
        this.dispatchEvent(new CustomEvent(Types_1.DownloadAppModalEvents.POPUP_OPEN), popupTemplate);
    };
    RealDoorComponent.prototype.closePopup = function (data) {
        this.dispatchEvent(new CustomEvent(Types_1.DownloadAppModalEvents.POPUP_CLOSE), data);
    };
    RealDoorComponent.prototype.getProductTypeByProductGroup = function (productGroup) {
        if (productGroup === void 0) { productGroup = ''; }
        var productType = productTypes.find(function (item) { return item.productGroups.includes(productGroup); });
        return (productType === null || productType === void 0 ? void 0 : productType.key) || 'photobook';
    };
    RealDoorComponent.prototype.getCampaignName = function (productType) {
        return productType ? campaignNameByProductType[this.platform][productType] : '';
    };
    return RealDoorComponent;
}(CustomEventTarget_1.CustomEventTarget));
exports.RealDoorComponent = RealDoorComponent;
